import React, { useEffect, useState } from 'react';
import Selection from '../../selection';

function UnsecuredPayment(props) {
    const [display, setDisplay] = useState(displayPage())

    useEffect(() => {
        if (props.page === 43 && props.store.missed_unsecured_payment_date !== undefined && props.store.missed_unsecured_payment_amount !== undefined) {
            let missed_unsecured_payment_date = props.store.missed_unsecured_payment_date
            let missed_unsecured_payment_amount = props.store.missed_unsecured_payment_amount
            delete props.store.missed_unsecured_payment_date
            delete props.store.missed_unsecured_payment_amount
            props.setValue({ ...props.store, missed_unsecured_payments: [...props.store.missed_unsecured_payments, {missed_unsecured_payment_date: missed_unsecured_payment_date, missed_unsecured_payment_amount: missed_unsecured_payment_amount }]})
        }
        setDisplay(displayPage())
    }, [props.page, props.store])

    function remove_missed_unsecured_payment(i) {
        props.store.missed_unsecured_payments.splice(i, 1)
        props.setValue({...props.store, missed_unsecured_payments: props.store.missed_unsecured_payments})
    }

    function displayPage() {
        switch (props.page) {
            case 40:
                return (
                    <Selection prev={props.prev} setPrev={props.setPrev} store={props.store} setPage={props.setPage} page={{
                        heading: "Have you ever missed an unsecured payment?",
                        info: {
                            id: "unsecured_payment_loan_modal",
                            text: "What is an unsecured payment?",
                            content: "An unsecured late payment covers credit agreements including mobile phone contracts, credit cards, overdrafts, personal loans, and other things where the debt isn’t secured against anything.",
                        },
                        buttons: {
                            "Yes": {
                                value: "YES",
                                next: 41
                            },
                            "No": {
                                value: "NO",
                                next: 44
                            }
                        }
                    }} id={"had_a_missed_unsecured_payment"} setValue={(e) => props.setValue({ ...props.store, had_a_missed_unsecured_payment: e, missed_unsecured_payments: [] })} />
                )

            case 41:
                return (
                    <Selection prev={props.prev} setPrev={props.setPrev} store={props.store} setPage={props.setPage} page={{
                        heading: "When did you last miss an unsecured payment?",
                        input: {
                            type: "month",
                            placeholder: "MM - YYYY",
                            id: "missed_unsecured_payment_date",
                            min: 7,
                            next: 42
                        }
                    }} id={"missed_unsecured_payment_date"} setValue={(e) => props.setValue({ ...props.store, missed_unsecured_payment_date: e })} />
                )

            case 42:
                return (
                    <Selection prev={props.prev} setPrev={props.setPrev} store={props.store} setPage={props.setPage} page={{
                        heading: "How much was the unsecured payment for?",
                        input: {
                            type: "number",
                            placeholder: "10000",
                            id: "missed_unsecured_payment_amount",
                            next: 43
                        }
                    }} id={"missed_unsecured_payment_amount"} setValue={(e) => props.setValue({ ...props.store, missed_unsecured_payment_amount: e })} />
                )

            case 43:
                return (
                    <Selection prev={props.prev} setPrev={props.setPrev} store={props.store} setPage={props.setPage} page={{
                        heading: "Please list all missed unsecured payments since May 2019",
                        info: {
                            id: "unsecured_payment_loan_modal_2",
                            text: "What is a unsecured payment?",
                            content: "An unsecured late payment covers credit agreements including mobile phone contracts, credit cards, overdrafts, personal loans, and other things where the debt isn’t secured against anything.",
                        },
                        collection: {
                            type: "missed_unsecured_payment",
                            add: 41
                        },
                        next: 44
                    }} id={"missed_unsecured_payment_collection"} setValue={(e) => {}} remove={(e) => remove_missed_unsecured_payment(e)} />
                )
        }
    }

    return (
        <div>
            {display}
        </div>
    );
}

export default UnsecuredPayment;